import { Button, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC } from "react";

type Props = {
	label: string;
	onClick: () => void;
};

export const InspirationEditButton: FC<Props> = ({ label, onClick }) => {
	const theme = useTheme();

	return (
		<Button
			variant="textLink"
			size="small"
			endIcon={<ChevronRight size={theme.iconSize.xxs} />}
			onClick={onClick}
		>
			{label}
		</Button>
	);
};
